export default {"src":"/_next/static/media/ic_league_rank_3.da8bceda.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};